const resource = {
  "approved": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmed"])},
  "denied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Denied"])},
  "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["List of confirmed payouts"])},
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payouts"])},
  "waiting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waiting"])}
}
export default resource